<template>
    <div>
        <div>
            <div class=" overflow-auto no_scroller px-3">
                <div class="main_wrapper no_scroller">
                    <div v-for="(timeline, index) in (shippingTimeline?.timeline || [])" :key="index + 'timeline'"
                        class="timeline_wrapper">
                        <div class="timeline_item">
                            <div class="liner_status">
                                <abbr>
                                    <i v-if="currentNo === index" class="current_ball"></i>
                                    <i v-if="currentNo < index" class="passed_ball"></i>
                                    <i v-if="currentNo > index" class=" w-[20px] h-[20px] inline-block">
                                        <img src="@/assets/images/checkmark.png" class="check_img" />
                                    </i>
                                </abbr>
                                <span :class="[(currentNo < index) && ' bg-gray-300']"></span>
                                <span :class="[(currentNo === index) && ' bg_orange']"></span>
                                <span :class="[(currentNo > index) && ' bg_green']"></span>
                            </div>
                            <p>
                                <b>{{ timeline?.label }}</b>
                                <span>From {{ timeline?.from }}</span>
                                <!-- <span>Ikorodu Terminal, Lagos, Nineria</span> -->
                                <span>{{ formatDate(timeline?.timestamp) }}</span>
                            </p>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    props: {
        shippingTimeline: {}
    },
    methods: {
        formatDate(date) {
            if(date === null || date === undefined) return "N/A";
            return moment(date).format('DD/MM/YY hh:mma') || "N/A"
        }
    },
    computed: {
        currentNo() {
            return this.shippingTimeline?.timeline.findIndex((item) => item?.current)
        }
    },
    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped>
.bg_green {
    @apply bg-primary-green
}

.bg_orange {
    @apply bg-primary-yellow
}

.timeline_item {
    @apply px-0 py-6 relative w-full;

    p {
        @apply text-gray-400 font-[300] text-sm pr-4;

        span {
            @apply block w-full mb-1
        }

        b {
            @apply mt-1 block w-full text-[15px] font-[500] text-gray-700 mb-1
        }
    }
}


.timeline_wrapper {
    @apply max-w-[330px] min-w-[250px] inline-block
}

.main_wrapper {
    @apply whitespace-nowrap
}

.liner_status {
    @apply w-full flex items-center gap-1 relative;

    span {
        @apply block h-[1px] rounded-md mr-1 absolute w-[calc(100%-30px)] left-[25px] top-[10px]
    }
}


.timeline_wrapper:nth-last-child(1) .timeline_item .liner_status {
    span {
        @apply bg-transparent
    }
}

.check_img {
    @apply inline-flex w-[20px] h-[20px] border-[1.5px] border-primary-yellow rounded-full bg-white justify-center items-center;

    &::before {
        content: "";
        @apply w-[70%] h-[70%] bg-primary-yellow rounded-full block
    }
}

.current_ball {
    @apply inline-flex w-[20px] h-[20px] border-[1.5px] border-primary-yellow rounded-full bg-white justify-center items-center object-contain;

    &::before {
        content: "";
        @apply w-[70%] h-[70%] bg-primary-yellow rounded-full block
    }
}

.passed_ball {
    @apply inline-flex w-[20px] h-[20px] border-[1.5px] border-gray-300 rounded-full bg-white justify-center items-center object-contain;

    &::before {
        content: "";
        @apply w-[70%] h-[70%] bg-gray-300 rounded-full block
    }
}
</style>